import {dependencies} from "../dependencies.mjs";

var {target, request, loggerFactory} = dependencies;
var logger = loggerFactory.createLogger('APISERVICES','info',true);

export class ApiServices{
	constructor(){}
	static request(url, response){
		var response = response;
		logger.info('request',url);
		var options = { 
			url, 
			headers : {
				'Accept' : 'application/json'
			}
		};
		request(options, (error, res, data) => {
			if (error) logger.error(`Request error: ${options.url.substr(0,60)}`,error); 
  			logger.debug('statusCode:', res && res.statusCode); 
            logger.info('response:',(!data) ? "null": data.substr(0,30)+'...');
            response(data);			
		});
		
	}
}

